import builder from '../builder';
import Car1 from '../../streamline-icons/light/car-1.svg';

export default builder('IconCar1Light', Car1);
